import { combineReducers } from 'redux';

import authReducer from './authSlice';
import unitReducer from './unitSlice';
import promotionsReducer from './promotionsSlice';
import lottoReducer from './lottoSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  unit: unitReducer,
  promotions: promotionsReducer,
  lotto: lottoReducer,
});

export default rootReducer;
